import { SupportedLanguage } from 'src/environments/environment.model';

export const DEFAULT_LANGUAGE: SupportedLanguage = {
  name: 'English',
  locale: 'en',
};
